/**
 * Ellipsis behaviour.
 */

(function (Drupal, $) {
  "use strict";

  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.ellipsis.attach}}
   */
  Drupal.behaviors.ellipsis = {
    attach: function (context, settings) {
      $('[data-ellipsis]').once('ellipsis', function (e) {

        var transformDebounced = _.debounce(transform, 700);
        $(window).on('resize', transformDebounced);
        transform();
        
        function transform() {
          $('[data-ellipsis]').each(function() {
            var maxHeight = $(this).attr('data-ellipsis');
            if(!maxHeight) {
              throw new Error('[data-ellipsis] must have a value.')
            }
            $(this).shave(maxHeight);
          });
        }

      });
    }
  }
  
})(Drupal, jQuery);
